"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = require("prop-types");

var colors = _interopRequireWildcard(require("../../style/colors"));

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj["default"] = obj;
    return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var Svg = _styledComponents["default"].svg.withConfig({
  displayName: "Svg",
  componentId: "kmf6fz-0"
})(["", ""], function (_ref) {
  var rotate = _ref.rotate;
  return "transform: rotate(".concat(rotate, "deg)");
});

var CloseIcon = function CloseIcon(_ref2) {
  var height = _ref2.height,
      width = _ref2.width,
      stroke = _ref2.stroke,
      rotate = _ref2.rotate;
  return _react["default"].createElement(Svg, {
    rotate: rotate,
    width: width,
    height: height,
    xmlns: "http://www.w3.org/2000/svg"
  }, _react["default"].createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _react["default"].createElement("path", {
    d: "M-4-4h20v20H-4z"
  }), _react["default"].createElement("path", {
    d: "M9.5355339 1.05025253c.3905243-.39052429 1.02368928-.39052429 1.41421357 0 .39052425.39052426.39052429 1.02368927 0 1.41421356l-8.48528138 8.48528138c-.39052425.39052425-1.0236893.39052425-1.41421356 0-.39052429-.3905243-.39052425-1.0236893 0-1.41421356l8.48528138-8.48528138z",
    fill: stroke,
    fillRule: "nonzero"
  }), _react["default"].createElement("path", {
    d: "M10.94974747 9.5355339c.39052425.39052426.39052429 1.02368928 0 1.41421357-.39052426.39052425-1.0236893.39052425-1.41421356 0L1.05025253 2.46446609c-.39052429-.39052429-.39052425-1.0236893 0-1.41421356.3905243-.39052429 1.02368927-.39052429 1.41421356 0l8.48528138 8.48528138z",
    fill: stroke,
    fillRule: "nonzero"
  })));
};

CloseIcon.propTypes = {
  width: _propTypes.PropTypes.string,
  height: _propTypes.PropTypes.string,
  stroke: _propTypes.PropTypes.string,
  rotate: _propTypes.PropTypes.number
};
CloseIcon.defaultProps = {
  width: '14px',
  height: '14px',
  stroke: colors.titleColor,
  rotate: 0
};
var _default = CloseIcon;
exports["default"] = _default;